import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import MarkdownSpan from "./../../components/MarkdownSpan";
import { CitationDiv } from "./elements";

const BibliographyEntry = ({ id }) => {
  const biblioData = useStaticQuery(graphql`
    query {
      allAirtable(filter: { table: { eq: "Bibliography" } }) {
        nodes {
          data {
            Citation
            Name
            Seaways_Images
          }
        }
      }
    }
  `).allAirtable.nodes.map((x) => x.data);

  const getCitation = (id) => {
    let found = "";
    for (let i = 0; i < biblioData.length; i++) {
      if (
        biblioData[i].Seaways_Images &&
        biblioData[i].Seaways_Images.indexOf(id) > -1
      ) {
        found = biblioData[i].Citation;
      }
    }
    return found ? (
      <CitationDiv id="bibliography">
        <strong>Citation:</strong>{" "}
        <span>
          <MarkdownSpan text={found} />
        </span>
      </CitationDiv>
    ) : null;
  };
  return getCitation(id);
};

export default BibliographyEntry;
